import React from 'react'
import styled from '@emotion/styled'
import {ColorPath} from 'types/Theme'

import {Icon, IconName, IconSize} from '@vio/atlas/Icon'
import mirror from '@vio/atlas/src/utils/mirror'

const IconWrapper = styled(Icon)`
  ${mirror()}
`

interface Props {
  size?: IconSize
  name: IconName
  colorPath?: ColorPath
}

export const MirroredIcon = ({size = 'sm', name, colorPath}: Props) => (
  <IconWrapper name={name} size={size} colorPath={colorPath} />
)
